// Liberação de cashback (admin → Cashback → "Liberação Cashbacks").
//
// O CustomGrid identifica a linha por `getRowId`; as linhas de /toApproval não
// têm `id`, então sem `cashbackApprovalRowId` o grid usaria o JSON da linha
// como id e o POST /cashback/approval receberia lixo.

export const cashbackApprovalRowId = (row) => row?.cashbackId;

// Normaliza a seleção do grid no payload de POST /:companyId/cashback/approval.
// Retorna { ok, cashbackIds } ou { ok: false, msg } quando não há o que aprovar.
export function buildCashbackApprovalPayload(selection) {
  const cashbackIds = Array.from(
    new Set(
      (Array.isArray(selection) ? selection : [])
        .map((id) => Number(id))
        .filter((id) => Number.isInteger(id) && id > 0),
    ),
  );

  if (cashbackIds.length === 0) {
    return { ok: false, msg: "Selecione ao menos um cashback para aprovar." };
  }

  return { ok: true, cashbackIds };
}
